/**
 * @generated SignedSource<<3167fd7fab5ab26bd7f6eabb42552c7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type cancel_reasons_insert_input = {
  account_name?: string | null | undefined;
  explanation?: string | null | undefined;
  paid_subscription?: boolean | null | undefined;
  reason?: string | null | undefined;
  subscription_id?: string | null | undefined;
};
export type CancelReasonsCreateMutation$variables = {
  reasons: ReadonlyArray<cancel_reasons_insert_input>;
};
export type CancelReasonsCreateMutation$data = {
  readonly insert_cancel_reasons: {
    readonly affected_rows: number;
  } | null | undefined;
};
export type CancelReasonsCreateMutation = {
  response: CancelReasonsCreateMutation$data;
  variables: CancelReasonsCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reasons"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "objects",
        "variableName": "reasons"
      }
    ],
    "concreteType": "cancel_reasons_mutation_response",
    "kind": "LinkedField",
    "name": "insert_cancel_reasons",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "affected_rows",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CancelReasonsCreateMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CancelReasonsCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "382616fccbf9c9f302e492ff699d73df",
    "id": null,
    "metadata": {},
    "name": "CancelReasonsCreateMutation",
    "operationKind": "mutation",
    "text": "mutation CancelReasonsCreateMutation(\n  $reasons: [cancel_reasons_insert_input!]!\n) {\n  insert_cancel_reasons(objects: $reasons) {\n    affected_rows\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9fcf5905a555feef1d4a481b75be395";

export default node;
